import { Stack } from '@mui/material'
import { z } from 'zod'

import { Typo } from '~/core/components/alias'
import { Title } from '~/core/components/title'
import { isNot } from '~/core/utils/is'
import { ContractAlert } from '~/features/guild/contract/components/contract-alert'
import { ContractInfo } from '~/features/guild/contract/components/contract-info'
import { EContractType } from '~/features/guild/contract/enums'
import { ContractInfo as IContractInfo } from '~/features/guild/contract/types'
import { formatContractTime } from '~/features/guild/contract/utils'

export const GuildDetails = (props: { info: IContractInfo }) => (
  <>
    <Title>{props.info.type === EContractType.APPLYING ? '加入公会' : '我的公会'}</Title>
    <Stack spacing={4}>
      <ContractAlert contract={props.info} />
      <ContractInfo
        fields={[
          { label: '公会名称', value: props.info.guild_name },
          { label: '会长M号', value: props.info.user_id.toString() },
          props.info.type === EContractType.APPLYING && {
            label: '签约时限',
            value: props.info.duration,
          },
          { label: '最低分成比例', value: props.info.rate_string },
          { label: '结算方式', value: props.info.settlement },
          ...(props.info.type === EContractType.APPLYING
            ? [{ label: '申请时间', value: formatContractTime(props.info.apply_time) }]
            : [
                { label: '合约开始时间', value: formatContractTime(props.info.contract_start) },
                { label: '合约结束时间', value: formatContractTime(props.info.contract_end) },
              ]),
        ].filter(isNot(z.boolean()))}
      />
      <Stack spacing={0.5}>
        <Typo variant="body1">提示</Typo>
        <Typo variant="body2" color="text.secondary">
          1. 主播与公会签约成功后，主播有义务在合约期间履行与公会的约定。
        </Typo>
        <Typo variant="body2" color="text.secondary">
          2. 如需续约，在签约期满前 15 日，您可于主播工作台操作续约，或者公会发起续约申请，
          系统会站内信提示主播需要进入主播工作台确认续签，方可续约成功。
        </Typo>
      </Stack>
    </Stack>
  </>
)
